/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
// ce composant doit etre refactorer
import React, { useState, ReactNode, useRef, useReducer, useEffect, useLayoutEffect } from "react";
import {
  AddCircleIcon,
  AddFillCircleIcon,
  ArrowLetAlt,
  AssistantNavigationIcon,
  Avatar1,
  AvatarParcours,
  Call,
  CloseIcon,
  CloseSmall,
  FlipCameraIcon,
  Info,
  Logo,
  LogoTransparent,
  Mail,
  RetrieveFillIcon,
  RetrieveIcon,
  TooltipImage,
  TrustingIcon,
} from "../../assets";
import { FieldArray, FormikProvider, useFormik,FormikContext, useFormikContext } from "formik";
import Form from "../ui/Forms";
import Input from "../ui/Forms/Input";
import Select from "../ui/Forms/Select";
// import CkEditorComponent from "../../ui/CkEditor";
import FileUpload from "../ui/Forms/Upload";
import WYSIWYGEditor from "../ui/WYSIWYGEditor";
import TextArea from "../ui/Forms/TextArea";
import ProgressBar from "../ui/ProgressBar";
import Counter from "../counter";
import { countries, countryCode } from "../../constants";
import { formSteps } from "../../schemas";
import { HoverButton } from "../ui/Buttons/Outline";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { stepsAtoms } from "../../store";

import ReactCountryFlag from "react-country-flag"
import { HoverButton2 } from "components/ui/Buttons/OutlineCopy";
import { _getTypeFreelance } from "services/parcours/create-entreprise.service";
import { _getDomains, _getFreelanceStatus, _getLangs, _getSkills, _getTools } from "services/parcours/freelance.service";
import RadioButton from "components/ui/Forms/Radio";
import { base64ToBlob, fileToBase64 } from "utils";



type StepProps = {
    onHandleSteps?: (step: number) => void;
};
  

export const Step1: React.FC<{handleNext?:any, type?:string, [key:string]:unknown}> = ({handleNext, type,...rest}:any) => {
    const [stepsState,setStepsAtom] = useRecoilState(stepsAtoms)
    const defaultCountryCode = 'fr'
    const {step1} = stepsState
    const {layout, inputClassName} = rest
    // console.log("step1",step1, step1[type])
    const formik:any = useFormik({
      initialValues: step1[type], 
      validationSchema:formSteps['step1'](type),
      validateOnMount:false,
      validateOnBlur:false,
      validateOnChange:false,
      onSubmit: values => {
  
        // console.log({values, step1})
        setStepsAtom((prev:any)=>{
          return {
            ...prev,
            step1: {
              ...prev['step1'],
              [type]: values

            },
            step5: {
              ...prev['step5'],
              [type]: {
                ...prev['step5'][type]
              }
            }
          }
        })
        handleNext()
      },
    });

    //Makes sure the changes are applied to recoil on the fly.
    //@Soultone ce qui se passait dans votre code avant c'est que le recoil state est seulement mis à jour après le submit
    //et cela crée un problème quand on utilise le formulaire sans aller vers le parcours
    //avec le useEffect on peut être sûr que recoil est toujours à jour après chaque modification d'un input ou d'un select
    //C'est la seule solution que j'ai trouvée pour le moment.
    useEffect(() => {
      setStepsAtom((prev:any) => ({
        ...prev,
        step1: {
          ...prev['step1'],
          [type]: formik.values
        }
      }));
    }, [formik.values]);


    const {handleChange, handleSubmit,errors, setFieldValue,values} = formik
  
    // console.log({errors})
  
    useEffect(()=>{
      if(values?.countryCode){
        const val = countryCode.find((el:any)=>el.label.toLowerCase() === values?.countryCode.toLowerCase())
        setFieldValue('telephone', `${val?.value.split(' ').shift()} ${values?.telephone.split(' ').slice(1).join(' ')??''}`)
      }
    },[values.countryCode])
  
    useEffect(()=>{
      const val= `${values?.telephone}`.split(' ')[0]
      const findout = countryCode.find((el:any)=>el.value.split(' ')[0].trim() === val.toLowerCase().trim())
      if(values?.telephone.length === 1 && values?.telephone[0]!='+'){
        setFieldValue('telephone', `+${values?.telephone}`)
      }else if(findout){
        setFieldValue('countryCode', findout.label.toLowerCase())
      }
    },[values.telephone])
  
  
    return (
      <div className="w-full ">
        <div className={`${layout === 'mobile' ? '' : ` ${type === 'enterprise'?'mb-4 mt-[7rem] lg:my-4':'my-4'} lg:w-3/4 xl:w-5/12  2xl:w-[38.188rem] mx-auto px-4 `}`}>
          {layout === 'mobile'? 
            null
            :
            (
              <div className="font-semibold text-2xl text-primary-blue">
                Inscrivez vous en 2 minutes seulement !
              </div>
            )
          }
          <FormikProvider value={formik}>
            <Form id="form-step1" onSubmit={handleSubmit} className={`grid ${layout  === 'mobile' ? 'grid-cols-1 mt-3' :'lg:grid-cols-2 gap-x-8 gap-y-3 my-6'}  font-bricolage-grotesque`}>
              <Form.Item className=""  name={type === 'enterprise'?"societe":'nom'} onChange={handleChange} {...(layout === 'mobile' ? {label:''}: {label:type === 'enterprise'?"Votre nom de société": "Nom"})}  >
                <Input placeholder={type === 'enterprise'?"Votre société": "Nom"} className={`${layout === 'mobile' ? inputClassName: ''} `} />
              </Form.Item>
              <Form.Item className="" name={type === 'enterprise'?"nom_prenom":'prenom'} onChange={handleChange} {...(layout === 'mobile' ? {label:''}: {label:type === 'enterprise'?"Votre nom et prénom": "Prénom"})} >
                <Input placeholder={type === 'enterprise'?"Nom & Prénom": "Prénom"} className={`${layout === 'mobile' ? inputClassName: ''} `}/>
              </Form.Item>
              <Form.Item className="col-span-full" name="mail" onChange={handleChange} {...(layout === 'mobile' ? {label:''}: {label:"Votre adresse mail"})}>
                <Input placeholder="Adresse mail" className={`${layout === 'mobile' ? inputClassName: ''} `} />
              </Form.Item>
              <Form.Item className={type === 'freelance'? 'col-span-full z-[100]':' z-50'} name="telephone" onChange={handleChange} {...(layout === 'mobile' ? {label:''}: {label:"Votre numéro de téléphone"})} >
                <Input placeholder="Numéro de téléphone"  
                  inputClassName={`${type === 'enterprise'?'!pl-6':'md:pl-0 pl-4'}`} 
                  addonWidthInRem={''}
                  className={`${layout === 'mobile' ? inputClassName: ''} `}
                  addonBefore={ 
                    <Select name="countryCode" 
                      options={countryCode} 
                      listClassName="" 
                      listStyle={layout === 'mobile' ? {backgroundColor:'#F4F4F5', zIndex:99}:{}} 
                      onChange={handleChange}
                      defaultValue={defaultCountryCode} 
                      placeholderClassName="w-[5.5rem]" 
                      keyValue="label"  
                      caretPosition={`${type === 'enterprise'?'left-10':'md:left-14 left-9'}`}
                      integratedSearchBar
                      customValue={(value:any)=><ReactCountryFlag countryCode={value} svg /> }
                      customLabel={(option:any)=>(
                        <div 
                          className="flex space-x-4 items-center"
                        >
                          <ReactCountryFlag countryCode={option.label} svg /> 
                          <div>{option.value}</div>
                        </div>
                        )
                      }   
                    />
                  } 
                />
              </Form.Item>
              {
                type === 'enterprise'?(
                  <Form.Item className="z-10" onChange={handleChange} name="pays" errors={errors.pays} {...(layout === 'mobile' ? {label:''}: {label:"Votre pays"})} >
                    <Select inputClassName={`${layout === 'mobile' ? '!bg-[#F4F4F5]': ''}`} options={countries} searchable listStyle={layout === 'mobile' ? {backgroundColor:'#F4F4F5'}:{}}  placeholder="Pays" className={`${layout === 'mobile' ? inputClassName: ''} my-3.5`} style={layout === 'mobile' ? {marginTop: '0'}:{}}/>
                  </Form.Item>
                ):null
              }

            </Form>
          </FormikProvider>
          {/* <Select options={countries} placeholder="Pays"  multiple />  */}
        </div>
      </div>
    )
}
  
  
let tempoElement:any=[];

export const Step2: React.FC = ({type,handleNext}:any) => {
    const [stepsState,setStepsAtom] = useRecoilState(stepsAtoms)
    const {step2} = stepsState
    console.log({step2:step2[type]})
    let domainSkillMapping: any= {},skillindex:number;

   
    // const items = [
    //   { label: "Développement Web & Mobile", value: "Développement Web & Mobile" },
    //   { label: "Design & Création", value: "Design & Création" },
    //   { label: "Marketing & Communication Digitale", value: "Marketing & Communication Digitale" },
    //   { label: "Ingénierie & Développement Logiciel", value: "Ingénierie & Développement Logiciel" },
    //   { label: "IT & Sécurité", value: "IT & Sécurité" },
    //   { label: "Data Science & Analytique", value: "Data Science & Analytique" },
    //   { label: "Gestion de Projet & Consulting", value: "Gestion de Projet & Consulting" },
    //   { label: "Intelligence Artificielle & Machine Learning", value: "Intelligence Artificielle & Machine Learning" },
    //   { label: "Comptabilité & Finance", value: "Comptabilité & Finance" },
    //   { label: "Ressources Humaines & Formation", value: "Ressources Humaines & Formation" },
    //   { label: "Support & Assistance", value: "Support & Assistance" },
    //   { label: "Édition & Rédaction", value: "Édition & Rédaction" }
    // ]
    
    
  
    
  
    const Freelance= ()=>{
      const [fileName, setFileName] = useState('')
      const [tools, setTools] = useState([])
      const [domainsAndSkills, setDomainsAndSkills] = useState({
        domains:[],
        skills:[]
      })
      const [isLoading, setisLoading] = useState(true)
      const [language, setLanguage] = useState([])
      const [showTooltip,setShowTooltip] = useState(false)
      const formik:any = useFormik({
        initialValues: step2[type],
        validationSchema:formSteps['step2'](type),
        validateOnMount:false,
        validateOnBlur:false,
        validateOnChange:false,
        onSubmit: values => {
          console.log({values})
          setStepsAtom((prev:any)=>{ 
            return {...prev, step2:{...prev['step2'], [type]:values}}
          })
          handleNext()
          // handleNext()
        }, 
      });
      
      const {handleChange, touched, handleSubmit,errors, setFieldValue, values} = formik
  
      const handleUpload = (file: any):void=>{
        try{
          const blobUrl = URL.createObjectURL(file)
          // setImgUrl(blobUrl)
          setFieldValue('file',{
            name:file.name,
            type: file.type,
            file
          })
          setFileName(file.name)
          // console.log({blobUrl})  
        }catch(err){
          console.log({err})
        }
      }


      const handleChangeDomainAndSkils = (value:any, index:number)=>{
        console.log("important",{value,skillindex})
        handleChange(value)
        for(let i=0;i<skillindex+1;i++){
          setFieldValue(`domainInfo[${index}].skills.${i}.skill`,'')
        }
        setDomainsAndSkills((prev:any)=>({...prev, skills: domainSkillMapping[value.target.value.value] || []}))
      }


      useEffect(()=>{
        // console.log({values, skillindex})
      },[values.domainInfo])



      useEffect(()=>{
        (async function(){
          try {

              let domains =  await _getDomains()
              let skills  = await _getSkills()
              let language = await _getLangs()
              let tools = await _getTools()


              console.log({language, tools})

              setTools(tools)



              setisLoading(false)

              setLanguage(language)

              setDomainsAndSkills({
                domains,
                skills:[]
              })

              setFileName(values.file.name)

              domainSkillMapping = domains.reduce((acc:any, domain:any) => {
                const domainSkills = skills
                    .filter((skill:any) => skill.domain_id === domain.id)
            
                acc[domain.label] = domainSkills;
                return acc;
              }, {});
              
              // console.log({domains, skills, domainSkillMapping})
          } catch (error) {
            // console.log({error})
          }
        })()
      },[])

      if(isLoading){
        return null;
      }else{
        return (
          <div className="md:w-full md:flex relative md:flex-shrink-0 md:px-4 lg:px-0 lg:pb-12 ">
            <div className="2xl:my-[3rem] lg:w-5/12 2xl:w-1/3 w-[92%] mx-auto pt-8 md:pt-0 lg:pt-8">
              <div className="font-semibold text-2xl text-primary-blue flex  space-x-4 items-center mb-4">
                <div>Spartiates ! Quel est votre métier ?</div>
                <img src={TooltipImage} alt="tooltip" onMouseEnter={()=>setShowTooltip(true)} onMouseLeave={()=>setShowTooltip(false)} className="cursor-pointer h-4 w-4" />
              </div>
              <FormikProvider value={formik}>
                <Form id="form-step2" onSubmit={handleSubmit} className="">
                  <FieldArray name="domainInfo" >
                    {
                      ({push, remove, form})=>{
                        let currInd:number;
                        return (
                          <>
                            {
                              form.values.domainInfo.map((val:any, index:number)=>{
                                currInd = index
                                return (
                                  <>
                                    {
                                      !index?(
                                        <div onClick={() =>
                                              push({ name: '', skills: [{ skill: '', experience: '', durationType: 'an' }] })
                                            } className="bg-[#DFDFE8] rounded-full font-normal text-[#4F4F4F]  py-1 inline-block px-3 mt-4 cursor-pointer">
                                          <div className="flex  space-x-2 ">
                                            <img src={AddCircleIcon} className="w-[0.813rem]" alt="" />
                                            <div>Ajouter un domaine</div>
                                          </div>
                                        </div>
                                      ):null
                                    }
                                    <div className="grid grid-cols-1 col-span-full gap-x-4 relative mt-[20px]">
                                      {index ? <img src={CloseIcon} alt="close icon" className="absolute -top-0 z-50 transform translate-y-1/2 cursor-pointer right-0" onClick={()=>remove(index)} />:null}
                                      <Form.Item  name={`domainInfo[${index}].name`}  onChange={(value:any)=>handleChangeDomainAndSkils(value, index)}  className="col-span-full " label="">
                                        <Select placeholder="Le domaine" searchable options={domainsAndSkills.domains} className="!mb-1"  keyValue="" customValue={(val:any)=>val?.value}    />
                                      </Form.Item>  
                                      <FieldArray name={`domainInfo.${index}.skills`}>
                                        {
                                          ({ push, remove }) => ( 
                                            <div>
                                              {/* {JSON.stringify(val)} */}
                                              {
                                                val.skills.map((skill:any, skillIndex:any) => {
                                                  skillindex = skillIndex
                                                  return  (<div className="grid grid-cols-2 gap-x-4">
                                                    <div className="flex space-x-2 items-center">
                                                      {
                                                        !skillIndex?<img src={AddFillCircleIcon} alt="add_circle_icon" className="cursor-pointer h-[1.25rem]"  onClick={() =>
                                                          push({ skill: '', experience: '', durationType: 'an' })
                                                        } />: (
                                                          <img src={RetrieveFillIcon} alt="add_circle_icon" className="cursor-pointer h-[1.25rem]"  onClick={() =>
                                                            remove(skillIndex)
                                                          } />
                                                        )
                                                      }
                                            
                                                      <Form.Item className="w-full max-w-[90%]" onChange={handleChange}  name={`domainInfo[${index}].skills.${skillIndex}.skill`} label="">
                                                        <Select options={domainsAndSkills.skills} searchable={domainsAndSkills.skills.length?true:false} placeholder="Compétence" listStyle={{zIndex:10}} keyValue="" customValue={(val:any)=>{console.log({val}); return val?.value?val.value:val}}   className="!mb-1"  />
                                                      </Form.Item>
                                                    </div>
                                                    <Form.Item className="" onChange={handleChange} name={`domainInfo[${index}].skills.${skillIndex}.experience`} label="">
                                                      <Input  placeholder="Expérience" className="!mb-1 w-auto"  addonWidthInRem={"6rem"} addonAfter={<Select   name={`domainInfo[${index}]..skills.${skillIndex}.durationType`} onChange={handleChange} defaultValue={'ans'} listStyle={{position:'relative',zIndex:99}} options={[{label: 'ans', value:'ans'}]} />} />
                                                    </Form.Item>
                                                  </div>)
                                                })
                                              }
                                            </div>
                                          )
                                        }
                                      </FieldArray>
                                      
                                    </div>
                                  </>
                                )
                              })
                            }
                            {/* <div className="flex justify-between col-span-2 items-center">
                              <div className="flex space-x-2 cursor-pointer hover:text-[#6F6F6F]" onClick={()=>push({name:'',skill:'',experience:''})}>
                                <img src={AddCircleIcon} alt="add_circle_icon" />
                                <div>Ajouter un domaine</div>
                              </div>
                              <div className="flex space-x-2 cursor-pointer hover:text-[#6F6F6F]" onClick={()=>currInd>0 ? remove(currInd):undefined}>
                                <img src={RetrieveIcon} alt="add_circle_icon" />
                                <div>Retirer un domaine</div>
                              </div>
                            </div> */}
                          </>
                        )
                      }
                    }
                  </FieldArray>
                  <div className="spacer border-t-[1px] border-[#BFBFBF] my-[30px]"  />
                  {/* {JSON.stringify(values)} */}
                  <div>
                    {
                        values?.domainInfo[0].name && (
                          <div className="rounded-3xl bg-white h-auto p-4">
                            <div className="font-semibold">Indiquez votre domaine favori : </div>
                            {
                              values?.domainInfo?.map((el:any)=>{
                                if(el.name.value){
                                  return (
                                    <Form.Item label={el.name.value} onChange={handleChange} className='flex flex-row-reverse justify-end items-center my-3 gap-x-2' name={'domaine_favoris'} value={el.name.id} checked={values['domaine_favoris']?.includes(el.name.id)}>
                                      <Input type="radio" className="h-auto my-auto" />
                                    </Form.Item>
                                  )
                                }
                              })
                            }
                          </div>
    
                        )

                      }

                      {errors.domaine_favoris && values?.domainInfo[0].name &&  <span className="text-red-400 text-xs">{errors.domaine_favoris}</span>}
                    </div>

                  {/* <Form.Item name="tools"  onChange={handleChange}  className="col-span-full my-[30px]" label="">
                    <Select searchable multiple options={tools}  placeholder="Selectionnez vos outils" className="my-1" customValue={(val:any)=>val?.value?val.value:val}   />
                  </Form.Item>  */}

                  <Form.Item name="language"  onChange={handleChange}  className="col-span-full my-[30px]" label="">
                    <Select searchable multiple options={language}  placeholder="Langue que vous maitrisez" className="" customValue={(val:any)=>val?.value?val.value:val}   />
                  </Form.Item> 

                  <Form.Item className="col-span-full" name="" label="">
                    <div>
                      <div className={`${errors && touched && errors.file?'ring-2 ring-red-500/50':''} rounded-full`}>
                        <FileUpload onChange={handleUpload} accept="audio/*" placeholderClassName="text-[16px]" placeholder={fileName || "Audio de présentation"}/>  
                     </div>
                      <div>{errors && touched && errors.file && (<span className="text-xs text-red-400">{errors.file}</span>)}</div>
                    </div>  
                  </Form.Item>
                  <Form.Item name="description" onChange={handleChange} className="col-span-full mt-2.5" label="">
                    <TextArea rows={6} className="placeholder:text-[#6F6F6F] p-2 md:p-4 outline-none" placeholder="Présentation" />  
                  </Form.Item>   
                </Form>
              </FormikProvider>
            </div>
    
            {
              showTooltip && (
                <div className="lg:bg-[#1D1D390D] bg-[#E9E9EC] top-0 absolute ml-[.9rem] sm:right-[4rem] sm:ml-0   w-[18.125rem] space-y-2 rounded-[20px] h-[14.875rem] transform translate-y-1/4 p-6">
                    <div className="flex justify-end lg:hidden">
                      <img src={CloseSmall} alt="close small" />
                    </div>
                      <img src={TooltipImage} alt="tooltip" className="h-4 w-4" />
                      <div className="text-[14px] text-[#6F6F6F]">
                        Indiquez votre spécialité ou domaine principal d'expertise (ex. : Développeur web, Graphiste, Télévendeur, Comptable).
                      </div>
                </div> 
              )
            } 
          </div>
        )
      }
  
    }
  
    const Entreprise = ()=>{
      const [types, setType]:any = useState([])
      let [items, setItems]:any = useState([])
      console.log({step2})
    
      const handleSelectType = (el:any)=>{
        
        setType(() => {
          let typeClone = [...tempoElement];
          if (typeClone.some((l:any)=>l.label.includes(el))) {
            typeClone = typeClone.filter((item: any) => item.label !== el);
          } else {
            typeClone.push({label:el,counter:1, id: items.find((j:any)=>j.label === el).id});
          }
          tempoElement = typeClone
          setFieldValue('type_freelance', typeClone.map((el:any)=>el.label).join(','))
          // console.log('nice',{tempoElement})
          return typeClone;
        });
      }
    
      const formik:any = useFormik({
        initialValues: {
          type_freelance: '',
        },
        validationSchema:formSteps['step2'](type),
        validateOnMount:false,
        validateOnBlur:false,
        validateOnChange:false,
        onSubmit: () => {
          alert('ok')
          // handleNext()
        }, 
      });
      const {setFieldValue} = formik
      const ref = useRef(false)
      useEffect(()=>{
        // console.log({all: step2[type]})
        setType(step2[type])
        // pour la partie mobile
        setFieldValue('type_freelance',step2[type]?.length?step2[type].map((el:any)=>el.label).join(','):"Type freelance") 
       },[])
  
       const onChange = (value:any, index:any)=>{
        tempoElement = Object.assign([], tempoElement)
        // console.log({tempoElement, index, el:tempoElement[index!]})
        tempoElement[index!] = {...types[index!], counter:value}
        // console.log({tempoElement})
       }




       const typeFreelance = async ()=>{
        try {
          let res = await _getTypeFreelance()
          console.log({res})
          let item = res.map((el:any)=>({label:el.name,value:el.name, id:el.id}))
          setItems(item)
        } catch (error) {
          console.log({error})
        }
       }
       
       useEffect(()=>{
        typeFreelance()
       },[])
  
       useEffect(()=>{
        ref.current =  true
        return ()=>{
          if(ref.current){
            localStorage.setItem('steps', JSON.stringify({...stepsState, step2:{...stepsState['step2'], enterprise:tempoElement}}))
          }
        }
       },[])
      
      return (
        <>
          <div className="lg:w-3/4 xl:w-3/5 lg:space-y-8 w-[calc(100vw-2rem)] flex-shrink-0 py-[6rem] sm:px-0 px-3 flex-grow-0  2xl:space-y-5">
            <div className="font-semibold text-2xl text-primary-blue md:text-center">
              Quel type de freelance recherchez-vous ?{" "}
              <span className="text-[.8em] font-light text-[#6F6F6F]">(1 minimum)</span>
            </div>
            <div className="justify-center hidden md:flex  lg:flex flex-wrap space-x-4 items-center">
              {/* {JSON.stringify(items)} */}
              {items.map((el:any, index:any) => (
                <div
                  key={index}
                  onClick={()=>handleSelectType(el.label)}
                  className={`${types.some((k:any)=>k?.label?.includes(el.label))?'bg-primary-blue text-white':'hover:bg-primary-blue bg-white hover:text-white'}  px-5 cursor-pointer h-[50px] rounded-full my-3 `}
                >
                  <div className="leading-[50px]">
                    {el.label}
                  </div>
                </div>
              ))}
            </div>
            {/* {JSON.stringify(values)} */}
            <FormikProvider value={formik}>
              <Form className="sm:hidden mt-4">
                <Form.Item name="type_freelance" onChange={(value:any)=>handleSelectType(value.target.value)}>
                  <Select   options={items} placeholder={"Type freelance"} />
                </Form.Item>
              </Form>
            </FormikProvider>
            {/* <div className="flex lg:flex-row text-sm  items-center flex-col-reverse font-semibold text-primary-blue  lg:space-x-2 w-4/6 lg:w-auto">
                      <div className="lg:text-wrap text-nowrap text-ellipsis overflow-hidden text-[16px] lg:text-lg">
                        {el.label} 
                      </div>
                      <span className="font-light text-[16px] font-bricolage-grotesque !leading-none"><span className="xl:inline-block  hidden">-</span> Nombre de freelance</span>
                    </div>
   */}
            {
              types.map((el:any, index:number)=>{
                return (
                  <div  className=" lg:mx-[4rem] rounded-2xl lg:rounded-full p-2 px-6 my-4 lg:my-0 text-lg flex justify-between items-center border-2 border-primary-blue relative">
                    <img src={CloseIcon} alt="close icon" className="absolute -top-4 transform translate-y-1/2 cursor-pointer right-0" onClick={()=>handleSelectType(el.label)} />
                    <div className="flex lg:flex-row text-[16px] lg:text-lg flex-col-reverse font-semibold text-primary-blue  lg:space-x-2 w-4/6 lg:w-auto">
                      <div className="lg:text-wrap text-nowrap text-ellipsis overflow-hidden">
                        {el.label} 
                      </div>
                      <span className="font-[400] text-[16px] text-primary-blue"><span className="lg:inline-block hidden">-</span> Nombre de freelance</span>
                    </div>
                    <div className="flex-shrink-0 ">
                      <Counter  counter={el.counter} index={index} onChange={onChange}  />
                    </div>
                  </div>
                )
              })
            }
          </div> 
        </>
      )
    }
  
    if(type === 'enterprise')
      return (
         <Entreprise />
      )
    else{
      return (
        // <div className="w-full flex flex-shrink-0 px-4 lg:px-0 lg:pb-12 ">
        //   <div className="2xl:my-[3rem] lg:w-5/12 2xl:w-1/3 mx-auto">
        //     <div className="font-semibold text-2xl text-primary-blue flex space-x-4 items-center mb-4">
        //       <div>Spartiates ! Quel est votre métier ?</div>
        //       <img src={TooltipImage} alt="tooltip" onMouseEnter={()=>setShowTooltip(true)} onMouseLeave={()=>setShowTooltip(false)} className="cursor-pointer h-4 w-4" />
        //     </div>
            <Freelance />
        //   </div>
  
          
        // </div>  
      )
    }
    
};
  
  
export const Step3: React.FC = ({tempoSteps}:any) => {
    const [steps, setStepsAtom] = useRecoilState(stepsAtoms)
    const {step3} = steps
    const items = [
        { label: "1 mois", value: "1 mois" },
        { label: "1 à 3 mois", value: "1 à 3 mois" },
        { label: "3 à 6 mois", value: "3 à 6 mois" },
        { label: "6 mois à 1 an", value: "6 mois à 1 an" },
        { label: "+ 1 an", value: "+ 1 an" },
        { label: "Je ne sais pas", value: "Je ne sais pas" },
    ];

    const formik = useFormik({
        initialValues: step3,
        validateOnMount:false,
        validateOnBlur:false,
        validateOnChange:false,
        onSubmit: () => {
        
        // handleNext()
        }, 
    })
    const {setFieldValue}= formik
    const handleChoice = (el:any)=>{
        setFieldValue('numberOfTime', el.label)
        setStepsAtom((prev:any)=>({...prev, step3:{numberOfTime:el.label}}))
    }

    useEffect(()=>{
      let val:any;
      if(tempoSteps < 3){

        
        val = JSON.parse(localStorage.getItem('steps')!)

        console.log({val})
        
        if(val){
          setFieldValue('numberOfTime', step3.numberOfTime)
          setStepsAtom((prev:any)=>{
            console.log({...prev, step4:{...val['step4'],enterprise:{...val['step4'].enterprise, base64File:val['step4'].enterprise?.base64File}}})
            return {...prev,step2:{...val['step2']}, step4:{...val['step4'],enterprise:{...val['step4'].enterprise, base64File:val['step4'].enterprise?.base64File}}}
          })
        }

      }else{
        setFieldValue('numberOfTime', step3.numberOfTime)
        localStorage.setItem('steps', JSON.stringify({...steps}))
      }
    },[])

    return (
        <div className="md:px-0 px-4">
        <div className="font-semibold text-2xl text-primary-blue md:text-center">
            Pour combien de temps auriez vous besoin de freelance ?
        </div>
        <div className="xl:flex xl:space-x-5 my-8 grid grid-cols-4 gap-y-8 gap-x-4">
            {items.map((el, index) => (
            <div
                onClick={()=>handleChoice(el)}
                key={index}
                className={`${el.label === formik.values.numberOfTime?'bg-primary-blue text-white':'hover:bg-primary-blue bg-white hover:text-white'} hidden md:block  px-6 cursor-pointer h-[50px] rounded-full `}
            >
                <div className="leading-[50px]">{el.label}</div>
            </div>
            ))}
        </div>

        <div className="sm:hidden mt-4">
            <FormikProvider value={formik}>
            <Form  className="" >
                <Form.Item name="numberOfTime" onChange={(e:any)=>handleChoice({label:e.target.value})}>
                <Select   options={items} placeholder="Combien de temps" />
                </Form.Item>
            </Form>
            </FormikProvider>

            {

            }
        </div>
        </div>
    );
};

export const Step4: React.FC = ({type, handleNext}:any) => {
    const [stepsState,setStepsAtom] = useRecoilState(stepsAtoms)
    const {step4} = stepsState
    const Freelance = ()=>{
        const formik:any = useFormik({
        initialValues: step4[type],
        validationSchema:formSteps['step4'](type),
        validateOnMount:false,
        validateOnBlur:false,
        validateOnChange:false,
        onSubmit: values => {
            setStepsAtom((prev:any)=>{
            return {...prev, step4:{...prev['step4'], [type]:values}}
            })
            handleNext()
        }, 
        });

        const currencies = [
        {label: '€', value:'€'}, 
        {label: '$', value:'$'}
        ]
        const [showTooltip,setShowTooltip] = useState(false)
        const [freelanceStatus, setFreelanceStatus]= useState([])
        const [tooltipText,setTooltipText] = useState('')
        const {handleChange, handleSubmit} = formik


        useEffect(()=>{
          (async ()=>{
            let res = await _getFreelanceStatus()
            console.log(res)
            setFreelanceStatus(res)
          })()
        },[])

        const  handleTooltip =  (type:any)=>{
          if(type ==='statut'){
            setTooltipText('Sélectionnez votre situation professionnelle actuelle (ex. : Freelance, Salarié, Micro-entrepreneur, Auto-entrepreneur, Indépendant, Étudiant).')
          }else{
            setTooltipText('Indiquez le montant que vous souhaitez percevoir chaque mois pour vos services (en euros). Ce tarif doit refléter vos compétences, votre expérience et la nature de vos prestations. Soyez réaliste et transparent.')
          }
          setShowTooltip(true)
        }
        return (
        <div className="flex w-full justify-center lg:w-[38.188rem] ">
            <div className="sm:px-0 px-4 flex-1">
            <div className="font-semibold text-2xl text-primary-blue">
                Votre profil professionnel
            </div> 
            <FormikProvider value={formik}>
                <Form id="form-step3" onSubmit={handleSubmit} className="grid grid-cols-1 gap-x-8 gap-y-3 my-6">
                <Form.Item className="" name="statut" label={
                    <div className="space-x-4 flex  items-center">
                    <div>Choisissez votre statut</div> 
                    <img src={TooltipImage} onMouseEnter={()=>handleTooltip('statut')} onMouseLeave={()=>setShowTooltip(false)} alt="tooltip" className="cursor-pointer h-4 w-4" />
                    </div>
                }>
                    <Select  options={freelanceStatus} keyValue="" customValue={(val:any)=>val?.value?val.value:val} onChange={handleChange} placeholder="Votre statut" />
                </Form.Item>
                <Form.Item className="" onChange={handleChange} name="tarifMensuel" label={
                    <div className="space-x-4 flex  items-center">
                    <div>Quel est votre tarif mensuel ?</div> 
                    <img src={TooltipImage} alt="tooltip" onMouseEnter={()=>handleTooltip('tarif')} onMouseLeave={()=>setShowTooltip(false)} className="cursor-pointer h-4 w-4" />
                    </div>
                }>
                    <Input placeholder="Tarif mensuel" addonWidthInRem={"5rem"}  addonAfter={<Select name="currency" onChange={handleChange}  defaultValue={'€'} options={currencies} />} />
                </Form.Item>
                </Form>
            </FormikProvider>
            </div> 

            {
            showTooltip && (
                <div className="lg:bg-[#1D1D390D] bg-[#E9E9EC] absolute ml-[.9rem] sm:right-[4rem] sm:ml-0   w-[18.125rem] space-y-2 rounded-[20px] h-[14.875rem] transform translate-y-1/4 p-6">
                    <div className="flex justify-end lg:hidden">
                    <img src={CloseSmall} alt="close small" />
                    </div>
                    <img src={TooltipImage} alt="tooltip" className="h-4 w-4" />
                    <div className="text-[14px] text-[#6F6F6F]">
                      {tooltipText}
                    </div>
                </div> 
            )
            } 

        </div>
        )
    }

    const [fileName, setFileName]= useState('')

    const [content,setContent] = useState('')
    
    const handleUpload = async (file:any)=>{
        console.log('upload logic trigger')
        console.log({
          isBlob: file instanceof Blob,
          isFile: file instanceof File,
          name: file?.name || 'N/A',
          size: file?.size, // in bytes
          type: file?.type || 'unknown',
          lastModified: file?.lastModified ? new Date(file?.lastModified).toLocaleString() : 'N/A'
        })

        const base64File = await fileToBase64(file)
        console.log({base64File})

        setFileName(file?.name)
        setStepsAtom((prev:any)=>{
        return {...prev, step4:{...prev['step4'],enterprise:{...prev['step4'].enterprise, base64File,fileType: file?.type, fileName: file?.name,fileObject:file?file:null}}}
        })
    }

    const handleChange = (value:any)=>{
        console.log('top', value)
        setContent(value)
        setStepsAtom((prev:any)=>{
        return {...prev, step4:{...prev['step4'],enterprise:{...prev['step4'].enterprise, description: value}}}
        })
    }

    useEffect(()=>{
        setFileName(step4.enterprise.fileName)
        setContent(step4.enterprise.description)
    },[])


    useEffect(()=>{
        const step = step4.enterprise;
        const file = step?.fileObject
        const fileStatus = {
          isBlob: file instanceof Blob,
          isFile: file instanceof File,
          name: file?.name || 'N/A',
          size: file?.size, 
          type: file?.type || 'unknown',
          lastModified: file?.lastModified ? new Date(file?.lastModified).toLocaleString() : 'N/A'
        }

        if(!(fileStatus.isBlob && fileStatus.isFile) &&  step.base64File ){
          const blob = base64ToBlob(step.base64File, step.fileType);
          const restoredFile = new File([blob], step.fileName, { type: step.fileType });

          setStepsAtom((prev:any)=>{
            return {...prev, step4:{...prev['step4'],enterprise:{...prev['step4'].enterprise, base64File: step.base64File,fileType: restoredFile?.type, fileName: restoredFile?.name,fileObject:restoredFile?restoredFile:null}}}
          })

          console.log(restoredFile instanceof Blob)
        }
    },[])

    if(type === 'enterprise')
        return (
        <div className="sm:px-0 px-2 w-11/12 lg:w-auto mx-auto">
            <div className="font-semibold text-2xl text-primary-blue my-6 lg:my-0">
            Dites nous en plus sur votre projet / missions
            </div>  
            <div className="flex space-x-5 my-6 relative">
            <WYSIWYGEditor onChange={handleChange} value={content} />
            </div>
            <div className="relative my-8">
            <FileUpload onChange={handleUpload} placeholder={fileName || 'Insérez un fichier (facultatif)'} />
            </div>
        </div>   
        )
    else{
        return (
        <Freelance />
        )
    }
}

export const Step5: React.FC = ({handleNext,type}:any) =>{
    const [imgUrl,setImgUrl]=useState('')
    const [stepsState,setStepsAtom] = useRecoilState(stepsAtoms)
    const {step5} = stepsState
    const formik:any = useFormik({
        initialValues: step5[type],
        validationSchema:formSteps['step5'],
        validateOnMount:false,
        validateOnBlur:false,
        validateOnChange:false,
        onSubmit: values => {
          console.log({values})
          setStepsAtom((prev:any)=>{
              return {...prev, step5:{...prev['step5'], [type]:values}}
          })
          handleNext()
        },
    });
    const [showTooltip,setShowTooltip] = useState(false)
    const {handleChange, handleSubmit,errors, setFieldValue,values} = formik

    let fileName;
    const handleUpload = (file: any):void=>{
        try{
        fileName = file.name
        console.log({file})
        const blobUrl = URL.createObjectURL(file)
        setImgUrl(blobUrl)
        setFieldValue('picture', {blobUrl,file})
        console.log({blobUrl})
        // console.log({fileUrl:blobUrl})
        }catch(err){
        console.log({err})
        }
    }


    console.log({errors})

    return (
        <div className="w-full flex">
        <FormikProvider value={formik}>
            <Form id={type ==='enterprise'?"form-step5":"form-step4"} onSubmit={handleSubmit}  className="my-4 lg:w-3/5 xl:w-5/12  2xl:w-1/3 mx-auto px-4 lg:px-0 space-y-6 lg:space-y-0">
            <div className="font-semibold text-2xl text-primary-blue">
                Votre profil utilisateur
            </div>
            <div className="flex lg:flex-row flex-col-reverse lg:justify-between lg:items-center">
                <div className="my-4 space-y-6">
                <div className="font-medium text-lg">Choisissez une photo</div>
                <p className="text-sm font-light pr-5 text-[#6F6F6F]">
                    Merci de soumettre une photo de bonne qualité pour des résultats optimaux. Suivez ces conseils pour vous assurer que votre photo soit acceptée.
                </p>
                </div>
                <Form.Item name="" className="relative lg:flex-shrink-0 w-[12rem] sm:w-[12rem] md:w-[12rem] lg:w-[11rem] xl:w-auto">
                <div>
                    <img onError={(e:any)=>{e.target.src=`${AvatarParcours}`; setFieldValue('picture', null)}} src={values.picture?.blobUrl ? values.picture?.blobUrl:(imgUrl || AvatarParcours)} alt="" className={`rounded-lg h-[10.938rem] ${errors?.picture && 'ring-2 ring-red-500/50'}  object-full ` } style={{aspectRatio:1}} />
                    <div className="absolute bottom-3 xl:-right-5 transform translate-y-1/2 -right-10 sm:-right-10 lg:-right-4 md:-right-10 -translate-x-[2rem] lg:translate-x-0 lg:translate-y-1/2">
                    <FileUpload
                        onChange={handleUpload} 
                        accept="image/*"
                        as={
                        <button type='button' className="bg-white p-4 rounded-full">
                            <img src={FlipCameraIcon} alt="" />
                        </button>
                        }
                    />
                    </div>
                </div>
                </Form.Item>
            </div>
            <div className="my-6">
                <Form.Item className="text-md"  name="username" onChange={handleChange}  labelClassName="text-primary-blue font-semibold" label={
                    <div className="space-x-4 flex  items-center">
                    <div>Votre nom d'utilisateur</div> 
                    <img src={TooltipImage} onMouseEnter={()=>setShowTooltip(true)} onMouseLeave={()=>setShowTooltip(false)} alt="tooltip" className="cursor-pointer h-4 w-4" />
                    </div>
                }>
                  <Input type="text" placeholder="Nom d'utilisateur" inputClassName=""   />
                </Form.Item>
            </div>
            </Form>
        </FormikProvider>
        {
            showTooltip && (
                <div className="lg:bg-[#1D1D390D] bg-[#E9E9EC] absolute ml-[1rem] sm:right-[4rem] sm:ml-0  w-[18.125rem] space-y-2 rounded-[20px] h-[14.875rem] transform translate-y-1/4 p-6">
                    <div className="flex justify-end lg:hidden">
                    <img src={CloseSmall} alt="close small" />
                    </div>
                    <img src={TooltipImage} alt="tooltip" className="h-4 w-4" />
                    <div className="text-[14px] text-[#6F6F6F]">
                      Choisissez un nom unique qui sera visible sur votre profil public. Cela peut être votre nom complet, un pseudonyme professionnel ou le nom de votre marque. Évitez les caractères spéciaux ou les espaces.
                    </div>
                </div> 
            )
            } 
        </div>
    )
}

export const Step6: React.FC = ({type, handleNext}:any) => {
    const [stepsState,setStepsAtom] = useRecoilState(stepsAtoms)
    const {step6} = stepsState
    const Enterprise = ()=>{
        const formik:any = useFormik({
        initialValues: step6[type],
        validationSchema:formSteps['step6'](type),
        validateOnMount:true,
        validateOnBlur:true,
        validateOnChange:true,
        onSubmit: values => {
            setStepsAtom((prev:any)=>{
            return {...prev, step6:{...prev['step6'], [type]:values}}
            })
            handleNext()
        },
        });
        const {handleChange, handleSubmit,errors}= formik
        console.log('top',{errors})

        return (
        <div className="w-full px-4 lg:px-0">
            <div className="my-4 lg:w-3/4 xl:w-1/3 mx-auto">
            <div className="font-semibold text-2xl text-primary-blue">
                Vos informations d'entreprises
            </div>
            <FormikProvider value={formik}>
                <Form id="form-step6" onSubmit={handleSubmit} className="grid grid-cols-1 gap-x-8 gap-y-3 my-6">
                <Form.Item name="function" className="" onChange={handleChange}  label="Fonction">
                    <Input placeholder="Entrer votre fonction dans l'entreprise" />
                </Form.Item>
                <Form.Item className="" name="id_num" onChange={handleChange}  label="Numéro d'identification">
                    <Input placeholder="Entrez votre numéro d'identification" />
                </Form.Item>
                </Form>
            </FormikProvider>
            </div>
        </div>  
        )
    }

    const Freelance = ()=>{
        const formik:any = useFormik({
        initialValues: step6[type],
        validationSchema:formSteps['step6'](type),
        validateOnMount:false,
        validateOnBlur:false,
        validateOnChange:false,
        onSubmit: values => {
            setStepsAtom((prev:any)=>{
            return {...prev, step6:{...prev['step6'], [type]:values}}
            })
            handleNext()
        },
        });
        const {handleChange, handleSubmit} = formik
        return (
        <div className="w-full px-4 lg:px-0">
            <div className="my-4 lg:w-3/4 xl:w-1/3  mx-auto">
            <div className="font-semibold text-2xl text-primary-blue">
                Vos informations de naissance
            </div>
            <FormikProvider value={formik}>
                <Form id="form-step5" onSubmit={handleSubmit} className="grid grid-cols-1 gap-x-8 gap-y-3 my-6">
                <Form.Item className="" name="date" onChange={handleChange} label="Votre date de naissance">
                    <Input placeholder="JJ/MM/AAAA" />
                </Form.Item>
                <Form.Item className="" name="ville" onChange={handleChange} label="Votre ville de naissance">
                    <Input placeholder="Ville de naissance" />
                </Form.Item>
                </Form>
            </FormikProvider>
            </div>
        </div>  
        )
    }
    if(type === 'enterprise'){
        return <Enterprise />
    }else{
        return <Freelance />
    }
};

export const Step7: React.FC = ({type,handleNext}:any) => {
    const [stepsState,setStepsAtom] = useRecoilState(stepsAtoms)
    const {step7} = stepsState

    const Freelance = ()=>{
        const formik:any = useFormik({
        initialValues: step7[type],
        validationSchema:formSteps['step7'](type),
        validateOnMount:false,
        validateOnBlur:false,
        validateOnChange:false,
        onSubmit: values => {
            setStepsAtom((prev:any)=>{
            return {...prev, step7:{...prev['step7'], [type]:values}}
            })
            handleNext()
        },
        });
        const {handleChange, handleSubmit} = formik
        return (
        <div className="w-full px-4 lg:px-0">
            <div className="my-4 lg:w-3/4 xl:w-1/3  mx-auto">
            <div className="font-semibold text-2xl text-primary-blue">
                Votre lieu de résidence
            </div>
            <FormikProvider value={formik}>
                <Form id="form-step6" onSubmit={handleSubmit} className="grid grid-cols-1 gap-x-8 gap-y-3 my-6">
                <Form.Item className="" name="pays" onChange={handleChange} label="Dans quel pays vivez-vous ?">
                    <Select options={countries} searchable placeholder="Pays" />
                </Form.Item> 
                <Form.Item className="" name="ville" onChange={handleChange} label="Dans quelle ville vivez-vous ?">
                    <Input placeholder="Votre ville" />
                </Form.Item>  
                </Form>
            </FormikProvider>
            </div>
        </div>
        )
    }

    const [fileName, setFileName]:any = useState('')
    const handleUpload = (file:any)=>{
        setFileName(file?.name)
        setStepsAtom((prev:any)=>{
        return {...prev, step7:{...prev['step7'],enterprise:{...prev['step7'].enterprise, id_doc_filename: file?.name,id_doc_file:file}}}
        })
    }

    useEffect(()=>{
        setFileName(step7.enterprise.id_doc_filename)
    },[])
    const [showTooltip, setShowTooltip]=useState(false)
    if(type === 'enterprise')
        return (
        <div className="w-full px-4 lg:px-0 flex ">
            <div className="my-4 lg:w-3/4 xl:w-1/3  mx-auto">
            <div className="flex space-x-4 items-center">
                <div className="font-semibold text-2xl text-primary-blue">
                Votre document <br /> 
                <div className="flex space-x-4 items-center"><div>d'identification d'entreprise</div>  <img src={TooltipImage} onMouseEnter={()=>setShowTooltip(true)} onMouseLeave={()=>setShowTooltip(false)} alt="tooltip" className="h-4 cursor-pointer" /></div>
                </div>
            </div>
            <Form className="grid grid-cols-1 gap-x-8 gap-y-3 my-6">
                <Form.Item className="" label="">
                <div className="">
                    <FileUpload onChange={handleUpload} placeholder={fileName || "Insérez votre document" }/>
                </div>
                </Form.Item>
            </Form>
            </div>

            {
            showTooltip && (
                <div className="lg:bg-[#1D1D390D] bg-[#E9E9EC] absolute  sm:right-[4rem] sm:ml-0   w-[18.125rem] space-y-2 rounded-[20px] h-[14.875rem] transform translate-y-1/4 p-6">
                    <div className="flex justify-end lg:hidden">
                    <img src={CloseSmall} alt="close small" />
                    </div>
                    <img src={TooltipImage} alt="tooltip " className="h-4 w-4" />
                    <div className="text-[14px] text-[#6F6F6F]">
                      Téléchargez un document officiel qui identifie votre entreprise (ex. : extrait Kbis, certificat d'immatriculation, ou tout autre justificatif équivalent).
                    </div>
                </div> 
            )
            } 
        </div>  
        )
    else{
        return (
            <Freelance />
        )
    }

};

export const Step8: React.FC<StepProps> = ({ onHandleSteps , type}:any) => {
    const address = [
        { label: "198 avenue de Verdun 92130, Issy les Moulineaux", icon: AssistantNavigationIcon },
        { label: "contact@wall-of-share.com", icon: Mail },
        { label: "+33 1 84 14 06 19", icon: Call },
    ];
    const navigate = useNavigate()

    return (
        <div className="w-full px-4 lg:px-0">
        <div className="my-4 lg:w-3/4 xl:w-1/3  mx-auto">
            <div className="flex flex-col items-start">
            <img src={TrustingIcon} alt="" className="h-12" />
            <div className="space-y-6">
                <div className="text-primary-blue font-semibold text-2xl mt-4">
                {type === 'enterprise'? 'Merci !': 'Accéder à votre profil !'}
                </div>
                <p className="text-[#6F6F6F]">
                    Votre inscription a bien été envoyé, Wall Of Share vous remercie. Vous allez recevoir un mail de confirmation très prochainement et vous serez contacté par notre équipe.
                </p>
                <HoverButton2 text="Retourner sur le site" type='button' handleNext={()=>navigate('/')}  />
            </div>
            <div className="w-full bg-white rounded-2xl p-6 mt-[4rem]">
                <ul className="space-y-4">
                {address.map((el, index) => (
                    <li key={index} className="flex space-x-3">
                    <img src={el.icon} alt="" />
                    <div>{el.label}</div>
                    </li>
                ))}
                </ul>
            </div>
            </div>
        </div>
        </div>
    );
};
